import { ref, set, get, push, update } from 'firebase/database';
import { database } from '../firebaseConfig';

const CREDITS_REF = 'Credits';

export const createCredits = (userId) => {
  set(ref(database, 'Credits/' + userId),{
      userId: userId,
      totalCreditsPurchased: 3,
      totalCreditsUsed: 0,
      totalCreditBalance: 3,
      lastUpdated: new Date(Date.now()).toLocaleString("en-US", { timeZone: "America/New_York" }), //mm/dd/yyyy hh:mmm:ss t
    })
    .then(() => {
      //console.log('Credits record created successfully');
    })
    .catch((error) => {
      //console.error("Error creating credits record: ", error);
    });
};

export const getCredits = async (userId) => {
  try {
    const creditsRef = ref(database, CREDITS_REF);
    const snapshot = await get(creditsRef);
    //console.log('inside getcredits:')
    if (snapshot.exists()) {
      const credits = [];
      snapshot.forEach((childSnapshot) => {
        const credit = childSnapshot.val();
        if (credit.userId === userId) {
          credits.push({ id: childSnapshot.key, ...credit });
        }
      });
      return credits.length > 0 ? credits[0] : null;
    }
    return null;
  } catch (error) {
    //console.error('Error getting credits:', error);
    throw error;
  }
};

export const updatePurchasedCredits = async (creditId, creditsPurchased, creditsUsed, creditBalance) => {
  try {
    const lastUpdated = new Date(Date.now()).toLocaleString("en-US", { timeZone: "America/New_York" }) //mm/dd/yyyy hh:mmm:ss t
    const creditRef = ref(database, `${CREDITS_REF}/${creditId}`);
    await update(creditRef, {
      totalCreditsPurchased: creditsPurchased,
      totalCreditsUsed: creditsUsed,
      totalCreditBalance: creditBalance,
      lastUpdated: lastUpdated
    });
    console.log('Credits updated successfully');
    return true;
  } catch (error) {
    //console.error('Error updating credits:', error);
    throw error;
  }
};


//if ever we need to delete any credits..use this after testing
export const deleteCredits = async (creditId) => {
  try {
    const creditRef = ref(database, `${CREDITS_REF}/${creditId}`);
    await set(creditRef, null);
    console.log('Credits deleted successfully');
    return true;
  } catch (error) {
    //console.error('Error deleting credits:', error);
    throw error;
  }
};
